import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import AmexImport from "./pages/AmexImport";
import Login from "./auth/Login";
import Recover2FA from "./auth/Recover2FA";
import ForgotPassword from "./auth/ForgotPassword";
import ResetPassword from "./auth/ResetPassword";
import ProtectedRoute from "./auth/ProtectedRoute";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import MockupGallery from "./pages/mockups/MockupGallery";
import MockupKlink from "./pages/mockups/MockupKlink";
import MockupMynte from "./pages/mockups/MockupMynte";
import MockupPling from "./pages/mockups/MockupPling";
import MockupLoftet from "./pages/mockups/MockupLoftet";
import MockupSirius from "./pages/mockups/MockupSirius";
import MockupKrans from "./pages/mockups/MockupKrans";
import MockupKompass from "./pages/mockups/MockupKompass";
import HeroVariants from "./pages/mockups/HeroVariants";
import Account from "./pages/Account";
import Signup from "./auth/Signup";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Support from "./pages/Support";
import FAQ from "./pages/FAQ";
import { SiriusThemeProvider } from "./sirius/ThemeProvider";
import { LanguageProvider } from "./i18n";
import "./sirius/theme.css";
import "./App.css";

function AmexImportRoute() {
  const { apiFetch, user } = useAuth();
  const [bm, setBm] = useState("");
  const [snip, setSnip] = useState("");
  const [trumfSnip, setTrumfSnip] = useState("");
  const [sasSnip, setSasSnip] = useState("");
  useEffect(() => {
    if (!user) return;
    const fetchText = async (path) => {
      try { return await apiFetch(path); } catch { return ""; }
    };
    fetchText("/api/amex/bookmarklet").then(setBm);
    fetchText("/api/amex/snippet").then(setSnip);
    fetchText("/api/programs/snippet?program=trumf").then(setTrumfSnip);
    fetchText("/api/programs/snippet?program=sas").then(setSasSnip);
  }, [user, apiFetch]);
  return <AmexImport bookmarklet={bm} snippet={snip} trumfSnippet={trumfSnip} sasSnippet={sasSnip} />;
}

function App() {
  return (
    <SiriusThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/account" element={<Account />} />
              <Route path="/login" element={<Login />} />
              <Route path="/recover-2fa" element={<Recover2FA />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/account/support" element={<Support />} />
              <Route path="/amex" element={
                <ProtectedRoute requireOwner>
                  <AmexImportRoute />
                </ProtectedRoute>
              } />
              <Route path="/mockups" element={<MockupGallery />} />
              <Route path="/mockups/hero-variants" element={<HeroVariants />} />
              <Route path="/mockups/klink" element={<MockupKlink />} />
              <Route path="/mockups/mynte" element={<MockupMynte />} />
              <Route path="/mockups/pling" element={<MockupPling />} />
              <Route path="/mockups/loftet" element={<MockupLoftet />} />
              <Route path="/mockups/sirius" element={<MockupSirius />} />
              <Route path="/mockups/krans" element={<MockupKrans />} />
              <Route path="/mockups/kompass" element={<MockupKompass />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </SiriusThemeProvider>
  );
}

export default App;
